const SpellCard = ({
  selected,
  disabled,
  dataIco,
  onSelect,
  cost,
  children,
}: {
  selected?: boolean
  disabled?: boolean
  dataIco: string
  cost: number
  onSelect: () => void
  children?: any
}) => {
  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          position: 'relative',
          height: 100,
          width: '25%',
        }}
        >
        <div
          style={{
            overflow: 'hidden',
            height: 100,
            display: 'flex',
            width: '100%',
          }}
        >
          <div
            onPointerDown={() => !disabled && onSelect()}
            className={`spell-card ${selected && !disabled ? 'selected' : ''} ${disabled ? 'disabled' : ''}`}
            style={{
              backgroundImage: `url('${process.env.PUBLIC_URL}/assets/images/theme/sheet.svg')`,
            }}
          >
            <div data-ico={dataIco} className="spell-card-text">
              {children}
            </div>
            {/* <img src={`${process.env.PUBLIC_URL}/assets/images/theme/sheet.svg`} /> */}
          </div>
          <div className={`spell-card-mana-cost ${selected && !disabled ? 'selected' : ''} ${disabled ? 'disabled' : ''}`} data-ico="🍬">
            <span className="spell-card-mana-cost-text">{cost}</span>
          </div>
        </div>
      </div>
    </>
  )
}

export default SpellCard
